/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_CurrenciesInputs */

const en_setup_currencies = /** @type {(inputs: Setup_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currencies`)
};

/**
* | output |
* | --- |
* | "Currencies" |
*
* @param {Setup_CurrenciesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_currencies = /** @type {((inputs?: Setup_CurrenciesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_CurrenciesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_currencies(inputs)
});